export type HrmBreadcrumb = {
  label: string;
  href?: string;
};

export const getHrmShellBreadcrumbs = (): HrmBreadcrumb[] => [];
